<template>
  <div>
    <authentication-forms-container :image="image">
      <h1 class="text-primary text-center" v-t="'verify_email.title'"></h1>
      <form>
        <router-link :to="{ name: 'Home' }" class="text-decoration-none">
          <button type="submit" class="my-5 btn btn-block btn-primary rounded-pill w-100"
                  v-t="'verify_email.back_to_site_button'"
          ></button>
        </router-link>
      </form>
    </authentication-forms-container>
  </div>
</template>
<script>
import FormErrorsManager from "../../validator/FormErrorsManager";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import router from "@/router";
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";


export default {
  name: "VerifyEmail1",
  components: {FormErrorsManager, AuthenticationFormsContainer},
  props: {
    image: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (process.env.NODE_ENV != 'development') {
      const id = this.$route.params.id;
      const hash = router.currentRoute.params.hash;
      const expires = router.currentRoute.query.expires;
      const signature = router.currentRoute.query.signature;
      const form = {
        id: id,
        hash: hash,
        expires: expires,
        signature: signature,
      };

      this.$store.dispatch("Authentication/verifyEmail", form);
    }

  },
};
</script>
<style scoped></style>